import { flow } from 'fp-ts/function';
import { compact, filter, find, get, map, matchesProperty, over, propertyOf, spread } from 'lodash/fp';

/**
 * Used to connect id selector with entities reducer root selector, i.e:
 *
 * @example
 * const userSelector = createEntitySelector(getUsers, getUserId);
 */
export const createEntitySelector = (entitiesSelector: $TSFixMe, entityIdSelector: $TSFixMe) =>
    flow(over([entityIdSelector, entitiesSelector]), spread(get));

/**
 * Creates matcher from value selector and name of the value key, i.e:
 *
 * @example
 * const getCurrentUserId = () => 'foo';
 * const foreignKeyMatcher = createForeignKeyMatcher('userId', getCurrentUserId);
 * foreignKeyMatcher({ userId: 'foo', name: 'bar' });
 * // returns true
 */
export const createForeignKeyMatcher = (foreignKeyName: $TSFixMe, valueSelector: $TSFixMe) =>
    flow(valueSelector, matchesProperty(foreignKeyName));

/**
 * Finds related entity by foreign key (~ different value then an id), expressing 1 to 1 relation:
 *
 * @example
 * const getCurrentServiceId = () => 'foo';
 * const currentServiceForeignKey = createForeignKeyMatcher('serviceId', getCurrentServiceId);
 * const getCurrentServiceEnterprise = createRelatedEntitySelector(getEnterprises, currentServiceForeignKey);
 *
 * getCurrentServiceEnterprise({ enterprises: { 42: { serviceId: 'foo' } } });
 * // returns { serviceId: 'foo' }
 */
export const createRelatedEntitySelector = (relatedEntitiesSelector: $TSFixMe, foreignKeyMatcher: $TSFixMe) =>
    flow(over([foreignKeyMatcher, relatedEntitiesSelector]), spread(find));

/**
 * Finds all related entities by foreign key, expressing 1 to n relation:
 *
 * @example
 * const currentUserForeignKey = createForeignKeyMatcher('userId', getCurrentUserId);
 * const getCurrentUserAccounts = createRelatedEntitiesSelector(getAccounts, currentUserForeignKey);
 */
export const createRelatedEntitiesSelector = (relatedEntitiesSelector: $TSFixMe, foreignKeyMatcher: $TSFixMe) =>
    // @ts-expect-error $TSFixMeError: Argument of type 'LodashFilter' is not assignable to parameter of type '(...args: any[]) => never[]'.
    flow(over([foreignKeyMatcher, relatedEntitiesSelector]), spread(filter));

// m -> n
export const createEntityToEntityMapper = (relatedEntitiesSelector: $TSFixMe, entityIdsSelector: $TSFixMe) =>
    flow(over([flow(relatedEntitiesSelector, propertyOf), entityIdsSelector]), spread(map), compact);
